// src/components/Navbar.js
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import BarChartIcon from "@mui/icons-material/BarChart";
import { deepPurple, red } from "@mui/material/colors";
import { useUser } from "../Contexts/UserContext";
import { getFormattedDate } from "../utils/getDate";
import LogoutIcon from "@mui/icons-material/Logout";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Badge from "@mui/material/Badge";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
function Navbar({ onMenuClick }) {
  const [alertCount, setAlertCount] = useState(0);
  const { user, logout, isAuthenticated } = useUser();
  const date = getFormattedDate();
  const navigate = useNavigate();
  const { RoleId } = user;
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `${API_URL}/facility/get-post-panic-reports/1/${user.CompCode}/${user.ClientId}/Testing/Suraj/6/${date}/${date}`
      ).then((res) => res.json());
      if (response.success) {
        setAlertCount(response.data.length);
        // setAlertCount(1);
      } else {
        alert("Cannot Get Active Alerts");
      }
    };
    fetchData();
  }, []);
  return (
    <AppBar position="static" className="nav-bar">
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={onMenuClick}
        >
          <MenuIcon className="col-red" />
        </IconButton>
        <Typography
          variant="span"
          style={{
            flexGrow: 1,
            color: "#000",
          }}
        >
          {user.ClientName}
        </Typography>

        {isAuthenticated && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <Typography variant="h6" noWrap sx={{ ml: 1, fontSize: 18 }}>
              {user.Username}
            </Typography> */}
            {/* <Button
              color="inherit"
              onClick={logout}
              startIcon={<LogoutIcon />}
              sx={{ width: "10px", padding: 0, border: "2px solid black" }}
            ></Button> */}
            {RoleId == 3 && (
              <IconButton
                color="primary"
                aria-label="user avatar"
                onClick={() => navigate("/detail")}
              >
                <Avatar
                  sx={{
                    bgcolor: "red",
                    width: 30,
                    height: 30,
                  }}
                >
                  <BarChartIcon sx={{ fontSize: "18px" }} />
                </Avatar>
              </IconButton>
            )}

            <IconButton
              color="primary"
              aria-label="user avatar"
              onClick={() => navigate("/panic")}
            >
              <Badge
                badgeContent={alertCount}
                color="secondary"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "12px", // Adjust the font size of the badge content
                  },
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: "red",
                    width: 30,
                    height: 30,
                  }}
                >
                  <ReportProblemIcon sx={{ fontSize: "18px" }} />
                </Avatar>
              </Badge>
            </IconButton>
            <IconButton
              // onClick={onClick}
              color="primary"
              aria-label="user avatar"
              onClick={logout}
            >
              <Avatar
                sx={{
                  bgcolor: "red",
                  width: 30,
                  height: 30,
                }}
              >
                <LogoutIcon sx={{ fontSize: "18px" }} />
              </Avatar>
            </IconButton>
            <Avatar
              sx={{
                bgcolor: deepPurple[500],
                width: 30,
                height: 30,
                marginLeft: "10px",
              }}
            >
              {user.UserName.charAt(0)}
            </Avatar>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
